import {DependencyList, useRef} from 'react';

const useChangeImmediate = (func: () => void, deps: DependencyList) => {
  const depsRef = useRef(deps);
  if (
    deps !== depsRef.current &&
    (deps.length !== depsRef.current.length ||
      depsRef.current.some((v, i) => v !== deps[i]))
  ) {
    depsRef.current = deps;
    func();
  }
};

export default useChangeImmediate;
